/* eslint-disable */
var icon = require('vue-svgicon')
icon.register({
  'map-navigation/out': {
    width: 16,
    height: 16,
    viewBox: '0 0 98 98',
    data: '<g data-name="Layer 2"><g data-name="Layer 1"><rect pid="0" width="98" height="98" rx="3.02" _fill="#373a36"/><path pid="1" d="M87.1 48.14l-11-11.67h-6.29l8.84 9.34H51.17v4.66h27.48l-8.84 9.34h6.25z" _fill="#fff"/><path pid="2" d="M66.9 56v16.4H46.38v12.29L21.77 72.38V19.05H66.9v20.52h-4.11V23.16H30l16.4 8.2v36.92h16.39V56z" _fill="#fff"/></g></g>'
  }
})
